import {Setting} from "./Setting";

export const anomalySetting: Setting = {
    key: "Anomaly",
    title: "Аномалии",
    description: "Аномалии представляют собой явления, зоны или объекты, нарушающие привычные законы природы, физики или магии. Они служат источником загадок, опасностей и возможностей для игроков, а также создают уникальную атмосферу и геймплейные элементы.",
    components: [
        {
            title: "Природа аномалий",
            subComponents: [
                {
                    title: "Физические",
                    description: `Нарушения законов гравитации (парящие камни, летающие острова). Временные искажения (ускорение или замедление времени, петли времени). Пространственные разрывы (порталы, карманы реальности, бесконечные коридоры).`,
                    examples: ["Парящие камни, летающие острова.", "Порталы, ведущие в другие миры.", "Петли времени, возвращающие в прошлое."]
                },
                {
                    title: "Энергетические",
                    description: `Концентрация магической энергии. Электромагнитные пульсации, радиация. Зоны, где невозможно использовать магию или технологии.`,
                    examples: ["Зона, где магия не работает.", "Поля с высокой радиацией.", "Пульсации, вызывающие галлюцинации."]
                },
                {
                    title: "Биологические",
                    description: `Мутации у растений, животных или людей. Разумные формы природы (агрессивные деревья, лоза-хищник). Появление новых форм жизни.`,
                    examples: ["Мутанты, обладающие сверхспособностями.", "Деревья, атакующие путников.", "Существо, состоящее из энергии."]
                }
            ]
        },
        {
            title: "Происхождение аномалий",
            subComponents: [
                {
                    title: "Естественное",
                    description: `Появление из-за геологических процессов, стихийных бедствий. Редкие природные явления, как магнитные бури или гейзеры энергии.`,
                    examples: ["Вулканические извержения, вызывающие аномалии.", "Магнитные бури, меняющие местность."]
                },
                {
                    title: "Магическое",
                    description: `Последствия магических ритуалов, экспериментов. Следы существ высших сил (богов, древних цивилизаций).`,
                    examples: ["Ритуал, вызывающий временной разлом.", "Артефакт, обладающий магической силой."]
                },
                {
                    title: "Технологическое",
                    description: `Последствия катастроф (взрывы, утечка энергии). Поломка или сбой высокотехнологичных устройств.`,
                    examples: ["Экспериментальное устройство, вызывающее аномалии.", "Взрыв, создающий временную петлю."]
                },
                {
                    title: "Неизвестное",
                    description: `Загадочные явления, которые невозможно объяснить.`,
                    examples: ["Чёрные дыры в пространстве.", "Аномалии, появляющиеся без причины."]
                }]
        },
        {
            title: "Типы аномалий",
            subComponents: [
                {
                    title: "Опасные",
                    description: `Мгновенно убивающие (вспышки, разрывы пространства). Медленно наносящие вред (радиация, магическое истощение).`,
                    examples: ["Вспышка, уничтожающая всё вокруг.", "Зона, где время исчезает."]
                },
                {
                    title: "Изолированные",
                    description: `Небольшие зоны, воздействие которых ограничено (локальный разрыв реальности).`,
                    examples: ["Карман реальности, ведущий в другое измерение.", "Зона, где гравитация изменена."]
                },
                {
                    title: "Глобальные",
                    description: `Аномалии, влияющие на огромные территории (магические штормы, затопление).`,
                    examples: ["Шторм, поглощающий всё на своём пути.", "Зона, где время идёт вспять."]
                },
                {
                    title: "Интерактивные",
                    description: `Аномалии, с которыми можно взаимодействовать (переместиться, получить ресурсы).`,
                    examples: ["Портал, ведущий в другую часть мира.", "Зона, где можно получить магическую энергию."]
                }]
        }
    ],
    prompt: {
        component: {
            list: "Опиши аномалии, которые характерны для истории. Опиши каждую аномалию отдельно указав ее название",
            single: "Сгенерируй аномалию, которая существует в мире истории",
            extend: "Дополни описание аномалии и разбей на абзацы. Как она влияет на мир и персонажей? Какие последствия она имеет?"
        },
        element: {
            list: "Опиши аномалии, которые характерны для истории. Опиши каждую аномалию отдельно указав ее название",
            single: "Сгенерируй аномалию, которая существует в мире истории",
            extend: "Дополни описание аномалии и разбей на абзацы. Как она влияет на мир и персонажей? Какие последствия она имеет?"
        },
        lore: {
            list: "Создай элементы лора на основе этой аномалии. Ее историю, мифы, влияние на мир и персонажей",
            single: "Создай элементы лора на основе этой аномалии. Опиши что-то одно, например: историю, мифы, влияние на мир и персонажей",
            extend: "Дополни описание элемента лора аномалии и разбей на абзацы."
        }
    }
}